import { object, optional, string, boolean, array } from 'valibot';

const carouselConfigSchema = object({
  arrow: optional(
    object({
      desktopHide: optional(boolean(), false),
      tabletHide: optional(boolean(), false),
      mobileHide: optional(boolean(), false),
    }),
  ),
  dots: optional(
    object({
      desktopHide: optional(boolean(), false),
      tabletHide: optional(boolean(), false),
      mobileHide: optional(boolean(), false),
    }),
  ),
});

const linkSchema = object({
  hide: optional(boolean(), false),
  altText: optional(string()),
  link: optional(string()),
  style: optional(string()),
  text: optional(string()),
  newTab: optional(boolean(), false),
});

const ctaInfoSchema = object({
  hideBothCtaAndActionLink: optional(boolean(), false),
  cta: optional(linkSchema),
  actionLink: optional(linkSchema),
});

const imageInfoSchema = object({
  file: optional(string()),
  imagefit: optional(string()),
});

const imageBlockInfoSchema = object({
  tablet: imageInfoSchema,
  desktop: imageInfoSchema,
  mobile: imageInfoSchema,
  fileUrl: optional(string()),
  newTab: optional(boolean(), false),
  altText: optional(string()),
});

const cardSchema = object({
  card: object({
    cta: ctaInfoSchema,
    imageBlock: imageBlockInfoSchema,
  }),
});

const titleCarouselSchema = object({
  hide: optional(boolean(), false),
  title1: string(),
  title2: string(),
});

export const CAROUSEL_SCHEMA = object({
  hide: optional(boolean(), false),
  title: titleCarouselSchema,
  carouselConfig: carouselConfigSchema,
  cards: array(cardSchema),
});
